import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Counter } from "@/components/Counter";
import { Author } from "@/components/Author";
import { Bento } from "@/components/Bento";
import { Quiz } from "@/components/Quiz";
import { EditorialBreak } from "@/components/EditorialBreak";
import { EmailCapture } from "@/components/EmailCapture";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Counter />
      <Author />
      <Bento />
      <Quiz />
      <EditorialBreak />
      <EmailCapture />
      <Pricing />
      <Faq />
      <Footer />
    </main>
  );
}
